import HttpProvider from "./httpProvider"
import { API } from "../constants/api"

class KitService {
  constructor() {
    this.http = HttpProvider
  }

  async getCities(search = "") {
    return await this.http.post(API.KIT.GET_CITIES(), { search })
  }

  async getCity(search = "") {
    return await this.http.post(API.KIT.GET_CITY(), { search })
  }

  async getRequest(id) {
    return await this.http.get(API.KIT.GET_REQUEST({ id }), false)
  }

  async getDebitors(search) {
    return await this.http.post(API.KIT.GET_DEBITORS(), { search })
  }

  async getDebitor(search) {
    return await this.http.post(API.KIT.GET_DEBITOR(), { search })
  }

  async updateRequest(data) {
    return await this.http.post(API.KIT.UPDATE_REQUEST(), data)
  }

  async createOrder(orderDeliveryRequestGroupId) {
    return await this.http.post(API.KIT.CREATE_ORDER({ id: orderDeliveryRequestGroupId }), false)
  }

  async getResponse(orderDeliveryRequestGroupId) {
    return await this.http.get(API.KIT.GET_RESPONSE({ id: orderDeliveryRequestGroupId }), false)
  }

  async getStatus(cargoNumber) {
    return await this.http.post(API.KIT.GET_STATUS(), { search: cargoNumber })
  }
}

export default new KitService()
